import React, { Component } from "react";
// import { Helmet } from "react-helmet";
// import Footer from 'components/Footer/Footer';
//import './style.css';
import 'pages/PKList/style.css';
// import PKimg from 'Assets/pksuccess.svg';
import Container from 'react-bootstrap/Container';
// import Button from "components/Button/Button";
// import Table from 'react-bootstrap/Table';
import { org_friendly_url } from "Api/Api";
// , user_entity_uuid, user_API, user_Status, user_Status_Ver, presentation_Creation_API, myHeaders_Auth_With_Cache_Control, myHeaders_With_Cache_Control, user_access_level, organization_user_access_level, user_account_level, apiUrl, searchUrl,
// import axios from "axios";
//import { getKey, dateConvert, unixDateConversion,origin, current_unix_stamp } from 'utils/Helper';
// import { getKey, dateConvert, unixDateConversion, get_current_unix_stamp } from 'utils/Helper';
// import FullPageSpinner from 'components/FullPageSpinner/FullPageSpinner';
// import ActivityIndicator from 'components/ActivityIndicator/ActivityIndicator';
// import EmptyMessage from 'components/EmptyMessage/EmptyMessage';
import PkList from 'components/PkListTable/PkList';
//import PkListTable from 'components/PkListTable/PkListTable';
//import PkListTableV2 from 'components/PkListTable/PkListTableV2';
import { withRouter } from "react-router-dom";
// import TableHeader from 'components/Table/TableHeaderV2';
// import home from 'Assets/home.svg';
import { local_routes } from 'utils/Routes';

class WorkspacePresentations extends Component {
    constructor(props) {
        super(props);
        this.state = {
        };
        
        this.workspace_base_url = "";

        if (org_friendly_url) {
          this.workspace_base_url = local_routes.workspace+"/"+org_friendly_url;

        }
        
    }
    
    
    componentWillUnmount() {
        clearInterval(this.interval);
    }
    
    
    // Api Integration Strats here
    componentDidMount() {
        console.log("MyPks componentDidMount");
    }

    render() {

            return (
                <React.Fragment>
                    <div>
                        <div className="pkListContainer">
                            <Container className="my-pk-list">
                                <PkList
                                  source_info={{entity_name: this.props.org_data.entity_name, entity_uuid: this.props.org_data.entity_uuid,entity_type:'organizations'}}
                                  referrer={`${this.workspace_base_url}${local_routes.manageworkspace}/presentations`}
                                />
                            </Container>
                        </div>
                    </div>

                </React.Fragment>
            );

    }
}

export default withRouter(WorkspacePresentations);
